export const DRAWER_MENU_OPEN = 'DRAWER_MENU_OPEN';
export const DRAWER_MENU_CLOSE = 'DRAWER_MENU_CLOSE';
